
  import {Component, Prop, Vue} from "vue-property-decorator";
  import _ from 'lodash';
  import {CustomApexChart} from "@/plugins/apexcharts";
  import {IDashboard} from "@/modules/Dashboard/interfaces/dashboard.interface";

  @Component({})
  export default class OccupancyDashboard extends Vue {

    @Prop() theme: string;

    get dashboardData(): IDashboard.IOccupancyData[] {
      return this.$store.state.dashboard.dashboards[this.activeChartType];
    }

    chartType = [
      { label: 'Сегодня', value: 'occupancyToday' },
      { label: 'Месяц', value: 'occupancyMonth' },
      { label: 'Год', value: 'occupancyYear' },
    ];
    activeChartType = 'occupancyToday';

    chart = null;
    apexChartName = 'apexchart-dashboard-occupancy';
    series = [];
    isLoading: boolean = true;
    options: any = null;

    created() {
      this.initOptions();
      this.prepareData();
      this.chart = new CustomApexChart(`.${this.apexChartName}`, this.options);
    }

    initOptions() {
      this.options = {
        chart: {
          type: 'bar',
          height: '100%',
          width: '100%',
          toolbar: { show: false },
          zoom: {
            enabled: false,
          }
        },
        theme: {
          mode: this.theme,
        },
        series: [],
        dataLabels: {
          enabled: true,
          formatter: (value) => this.$options.filters.currency(value, '', ' ', 0)
        },
        grid: { show: false },
        xaxis: {
          tickPlacement: 'on',
          labels: {
            show: true,
            rotate: -90,
            style: {
              fontSize: '14px',
            },
          },
        },
        yaxis: { show: false },
        fill: { opacity: 1 },
        tooltip: {
          y: {
            formatter: (value) => this.$options.filters.currency(value, '', ' ', 0),
          }
        },
        legend: {
          show: false,
        }
      };
    }

    prepareData() {
      this.series = [];
      let items = [
        { label: '', prop: 'count', color: '#00953F', },
      ];

      let array = _.sortBy(this.dashboardData, [(item) => item.hour]);
      items.forEach(item => {
        this.series.push({
          name: item.label,
          data: array.map(values => values[item.prop]),
          color: item.color
        });
      });
      this.options.series = this.series;
      this.options.xaxis.categories = array.map(values => `${values.hour}`);
    }

    changeType(newType: string) {
      this.activeChartType = newType;
      this.updateChart();
    }

    updateChart() {
      this.prepareData();
      if (this.chart.chart) this.chart.chart.updateSeries(this.options.series);
      // this.chart.chart.updateOptions({
      //   xaxis: {
      //     categories: this.options.xaxis.categories,
      //   }
      // }, true);
    }

    destroyed() {
      if (this.chart) this.chart.destroyChart();
    }
  }
